<app-modal [isOpen]="isOpen" [showCloseButton]="false" (close)="onClose()" className="max-w-lg mx-4">
  <div class="p-6">
    <div class="mb-5 flex items-start gap-3">
      <span class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-warning-50 text-warning-500 dark:bg-warning-500/15">
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0V11.25A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
        </svg>
      </span>
      <div>
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Reprogramar reunión</h3>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {{ meeting?.title }}
        </p>
      </div>
    </div>

    <div class="space-y-4">
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Nueva fecha y hora <span class="text-error-500">*</span>
        </label>
        <!-- INC 79: `min` impide elegir el pasado desde el propio selector; la validación
             de confirmar() cubre el tecleo manual, que `min` no bloquea. -->
        <input
          type="datetime-local"
          [(ngModel)]="nuevoInicio"
          [min]="minInicio"
          [disabled]="saving"
          class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:text-white/90" />
        @if (originalVencida) {
          <p class="mt-1.5 text-xs text-gray-500 dark:text-gray-400">
            La fecha original ya venció; se propone la próxima hora disponible.
          </p>
        }
      </div>

      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Motivo (opcional)
        </label>
        <textarea
          [(ngModel)]="motivo"
          [disabled]="saving"
          rows="3"
          placeholder="Motivo de la reprogramación…"
          class="w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 text-sm text-gray-800 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:text-white/90"></textarea>
      </div>
    </div>

    <div class="mt-6 flex justify-end gap-3">
      <button
        type="button"
        (click)="onClose()"
        [disabled]="saving"
        class="rounded-lg border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">
        Volver
      </button>
      <button
        type="button"
        (click)="confirmar()"
        [disabled]="saving"
        class="rounded-lg bg-brand-500 px-4 py-2.5 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50">
        {{ saving ? 'Reprogramando…' : 'Reprogramar' }}
      </button>
    </div>
  </div>
</app-modal>
